export default __webpack_public_path__ + "static/media/blackOutline3.d0dd7bf4.png";